module.exports = __webpack_public_path__ + "img/shape8.8b5c6f24.png";